import React, { useState } from "react";
import { resetPasswordUser } from "../api/authApi";
import PasswordInput from "./PasswordInput";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const token = window.location.pathname.split("/reset-password/")[1];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("لینک بازیابی رمز عبور معتبر نیست.");
      return;
    }

    if (!password || !confirmPassword) {
      setError("لطفاً رمز عبور و تکرار آن را وارد کنید.");
      return;
    }

    if (password.length < 6) {
      setError("رمز عبور باید حداقل ۶ کاراکتر باشد.");
      return;
    }

    if (password !== confirmPassword) {
      setError("رمز عبور و تکرار آن یکسان نیستند.");
      return;
    }

    try {
      setLoading(true);

      await resetPasswordUser(token, {
        password,
        confirmPassword,
      });

      setShowSuccessModal(true);
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.message || "لینک بازیابی نامعتبر یا منقضی شده است.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">
        <div className="auth-icon">🔐</div>
        <h2>تغییر رمز عبور</h2>
        <p>رمز عبور جدید خود را وارد کنید.</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label>رمز عبور جدید</label>
            <PasswordInput
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="حداقل ۶ کاراکتر"
              required
              autoComplete="new-password"
            />
          </div>

          <div className="auth-field">
            <label>تکرار رمز عبور جدید</label>
            <PasswordInput
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="رمز عبور را دوباره وارد کنید"
              required
              autoComplete="new-password"
            />
          </div>

          <button className="auth-submit" type="submit" disabled={loading}>
            {loading ? "در حال تغییر رمز..." : "تغییر رمز عبور"}
          </button>
        </form>
      </div>

      {showSuccessModal && (
        <div className="success-modal-overlay">
          <div className="success-modal">
            <div className="success-icon">✓</div>

            <h3>رمز عبور با موفقیت تغییر کرد</h3>

            <p>اکنون می‌توانید با رمز عبور جدید وارد حساب کاربری خود شوید.</p>

            <button
              type="button"
              onClick={() => {
                window.location.href = "/";
              }}
            >
              بازگشت به صفحه اصلی
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ResetPassword;
